import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';

export const shipperInfoStyles = (Component) => styled(Component)`
  display: flex;
  flex: 1;
  background-color: var(--grey100);

  .column {
    box-sizing: content-box;
    padding: 8px 16px;

    &_align-right {
      margin-left: auto;
      width: 200px;

      .item {
        max-width: 200px;
      }
    }
  }

  .item {
    margin-bottom: 6px;
  }

  .last {
    margin: 0;
  }
`;

export const userInfoStyles = (Component) => styled(Component)`
  display: flex;
  flex: 1;
  padding: 8px 16px 0 16px;
  justify-content: space-between;

  .email {
    width: 200px;
  }
  .column {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .phone {
    margin-left: auto;
    margin-right: 16px;
  }
`;

export const StyledTooltip = styled(ReactTooltip)`
  && {
    background: var(--white);
    opacity: 1;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    margin-top: 2rem;
  }
`;

export const shipperContactsStyles = (Component) => styled(Component)`
  padding: 0 1.8rem;

  button {
    max-height: 13px;
  }

  .shipper-contacts {
    &__copy-btn {
      display: inline-block;
      padding-right: 0;
      height: 1.2rem;
    }

    &_other-contacts {
      font-weight: 500;
    }

    &-details {
      max-height: 324px;
      overflow-y: auto;

      &__container {
        &:not(:last-child) {
          border-bottom: 1px solid var(--grey300);
          padding-bottom: 1rem;
          margin-bottom: 0.8rem;
        }
      }
      &__other-toggle {
        display: inline-block;
        text-transform: uppercase;
        height: 1.2rem;
      }
      &__title {
        color: var(--grey700);
        text-transform: uppercase;
        font-weight: 500;
        font-size: 1.2rem;
      }
      &__name {
        width: 112px;
        padding-right: 0.8rem;
      }
      &__contact-instructions {
        width: 192px;
        padding: 0 0.8rem;
      }
      &__phone {
        width: 106px;
        padding: 0 0.8rem;

        button {
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
          width: 100%;
        }
      }
      &__email {
        width: 216px;
        padding-left: 0.8rem;
        button {
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
          width: 100%;
        }
      }
    }
  }
`;
